import Handlebars from 'handlebars';
import { formatDate } from './constants';

// Equals
Handlebars.registerHelper('equals', function (a, b, options) {
	return a == b ? options.fn(this) : options.inverse(this);
});

// Not Equals
Handlebars.registerHelper('notEquals', function (a, b, options) {
	return a != b ? options.fn(this) : options.inverse(this);
});

// Greater than
Handlebars.registerHelper('greaterThan', function (a, b, options) {
	return a > b ? options.fn(this) : options.inverse(this);
});

// Greater than or equal
Handlebars.registerHelper('greaterThanOrEqual', function (a, b, options) {
	return a >= b ? options.fn(this) : options.inverse(this);
});

// Less than
Handlebars.registerHelper('lessThan', function (a, b, options) {
	return a < b ? options.fn(this) : options.inverse(this);
});

// Less than or equal
Handlebars.registerHelper('lessThanOrEqual', function (a, b, options) {
	return a <= b ? options.fn(this) : options.inverse(this);
});

// And (truthy values)
Handlebars.registerHelper('and', function (...args) {
	const options = args.pop();
	return args.every(Boolean) ? options.fn(this) : options.inverse(this);
});

// Or (truthy values)
Handlebars.registerHelper('or', function (...args) {
	const options = args.pop();
	return args.some(Boolean) ? options.fn(this) : options.inverse(this);
});

// Not (negate a single value)
Handlebars.registerHelper('not', function (value) {
	return !value;
});

// If exists (truthy check)
Handlebars.registerHelper('exists', function (value, options) {
	return value ? options.fn(this) : options.inverse(this);
});

// To Uppercase
Handlebars.registerHelper('uppercase', function (value) {
	return typeof value === 'string' ? value.toUpperCase() : value;
});

// To Lowercase
Handlebars.registerHelper('lowercase', function (value) {
	return typeof value === 'string' ? value.toLowerCase() : value;
});

// Join array (useful for tags or lists)
Handlebars.registerHelper('join', function (array, separator = ', ') {
	return Array.isArray(array) ? array.join(separator) : array;
});

// Handlebars.registerHelper('insert', function (key, options) {
// Handlebars.registerHelper('insert', function (...args) {
//     console.log("ARGS", args);
//     const [key, options] = args;
// 	const context = options?.data?.root ?? this;
//     console.log('register helper [insert]', key, options);
// 	const keys = key.split('.');
// 	let value = context;

// 	for (const k of keys) {
// 		if (value == null) break;
// 		value = value[k];
// 	}

// 	return value != null ? value : '';
// });
function resolvePath(obj, path) {
	const keys = path.split('.');
	let value = obj;
	for (const key of keys) {
		if (value == null) return undefined;
		value = value[key];
	}
	return value;
}
Handlebars.registerHelper('insert', function (...args) {
	const options = args.pop(); // The last argument is always the options object
	const context = options?.data?.root ?? this;

	// Resolve each argument:
	const resolvedArgs = args.map((arg) => {
		if (typeof arg === 'string' && arg.includes('.')) {
			// Attempt to resolve it as a path
			return resolvePath(context, arg);
		}
		return arg;
	});

	// Return the first non-null, non-undefined value
	for (const val of resolvedArgs) {
		if (val != null) {
			return val;
		}
	}

	return '';
});

Handlebars.registerHelper('length', function (value) {
	if (Array.isArray(value) || typeof value === 'string') {
		return value.length;
	}
	return 0;
});

Handlebars.registerHelper('concat', function (...args) {
	const options = args.pop();
	return args.join('');
});

Handlebars.registerHelper('formatDate', function (dateString, format = 'YYYY-MM-DD') {
	try {
		const date = new Date(dateString);
		return formatDate(date);
		// return date.toISOString().split('T')[0]; // simple ISO date fallback
	} catch (e) {
		return dateString;
	}
});

export default Handlebars;
